import type {
  TileOptionSelections,
  WidthBasedProduct,
  VergeOption
} from "../types";

export const getIsLeftDoubleWingedTileSelected = (
  vergeSelection: TileOptionSelections["verge"]
): vergeSelection is WidthBasedProduct => {
  if (!vergeSelection) {
    return false;
  }

  if (vergeSelection === "none") {
    return false;
  }

  return !("left" in vergeSelection);
};

export const getIsLeftDoubleWingedTile = (
  vergeOption?: VergeOption | WidthBasedProduct
): vergeOption is WidthBasedProduct => {
  if (!vergeOption) {
    return false;
  }

  return !("left" in vergeOption);
};
